export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9422_BEHAVIOUR_': 'Behaviour:',
    '_9986_NO_BEHAVIOUR_SELECTED': 'No Behaviour Selected',
    '_10016_ADD_BEHAVIOUR': 'Add Behaviour',
    '_9423_SUB_BEHAVIOUR_': 'Tactic:',
    '_9987_NO_SUB_BEHAVIOUR_SELECTED': 'No Tactic Selected',
    '_9988_PARTICIPANTS': 'Participants:',
    '_102_USER_NAME': 'User Name',
    '_9982_CONVERSATION': 'Conversation',
    '_9990_REMOVE_ALL_NOTES': 'Remove All Notes',
    '_9983_COPY': 'Copy',
    '_9984_CREATE_NEW_OBSERVATION': 'Create new observation',
    '_9996_TRANSCRIPTS': 'Transcripts',
    '_10056_TRANSCRIPT_SAVED': 'Transcript Saved',
    '_10057_ALL_PARTICIPANTS': 'All Participants',
    '_10051_NO_TRANSCRIPTS_AVAILABLE': 'No Transcripts Available',
    '_10058_CREATED_ON_': 'Created on:',
    '_9665_RESET': 'Reset',
    '_710_SEARCH': 'Search',
    '_9479_CONFIRMATION': 'Confirmation',
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_9415_PUBLISH': 'Publish',
    '_9488_ADD_COMMITMENT_NOTE': 'Add Commitment Note',
    '_121_CANCEL': 'Cancel',
    '_9507_A_COMMITMENT_CANNOT_BE_CREATED_UPDATED_WITHOUT_A_FOCUS_': 'A commitment cannot be created/updated without a focus.',
    '_9497_DATE___TIME_': 'Date & Time:',
    '_9774_START_DATE_': 'Start Date:',
    '_73_END_DATE_': 'End Date',
    '_11038_DO_YOU_WANT_TO_PERMANENTLY_DELETE_THESE_LINES': 'Removing lines from the transcript will cause a mismatch between the original in teams and what is displayed in COMPAS. Would you like to permanently remove these lines from the transcript in COMPAS?',
    '_11032_ADD_OBSERVATION_NOTE': 'Add Observation Note',
    '_11029_DELETE_CONVERSATION': 'Delete Conversation',
    '_11033_WOULD_YOU_LIKE_TO_PUBLISH_THESE_COMMITMENT_NOTES_AND_CONTINUE': 'Would you like to publish these commitment notes and continue making notes from this transcript or publish these notes and go to the commitment',
    '_11039_PUBLISH_AND_CONTINUE': 'Publish - Stay on Transcript',
    '_11040_PUBLISH_AND_CLOSE': 'Publish - Go to Commitment',
    '_11041_CHAT': 'Chat'
};
